import { useCallback, useMemo } from 'react';

const useYupValidationResolver = (schema) => {
    const validationSchema = useMemo(
        () =>
            schema,
        [schema]
    );

    return useCallback(async data => {
        try {
            const values = await validationSchema.validate(data, {
                abortEarly: false,
            });

            return {
                values,
                errors: {},
            };
        } catch (errors) {
            return {
                values: {},
                errors: errors.inner.reduce((allErrors, currentError) => ({
                    ...allErrors,
                    [currentError.path]: {
                        type: currentError.type ? 'validation' : null,
                        message: currentError.message,
                    },
                }), {}),
            };
        }
    }, [validationSchema]);
}

export default useYupValidationResolver;
